import {ModalProps, Text, Modal, ModalOverlay, ModalContent, Center, Flex, Button} from '@chakra-ui/react';
import {useMyPowersQuery} from '@eksab/features/profile/hooks';
import {useConsumePowerMutation} from '@eksab/hooks/useConsumePowersMutation';
import {useTranslate} from '@eksab/i18n';
import {useRouter} from 'next/router';
import {useInvalidateNewsQuery} from '../hooks';
import {LockIcon} from './LockIcon';

export const UnlockModal = ({
  news_id,
  onUnlock,
  ...props
}: Omit<ModalProps, 'children'> & {news_id: number; onUnlock?: () => void}) => {
  const t = useTranslate();
  const powersQuery = useMyPowersQuery({key: 'premium_content', 'is-expired': false});
  const router = useRouter();
  const invalidateNewsQuery = useInvalidateNewsQuery();

  const consumeMutation = useConsumePowerMutation();
  return (
    <Modal {...props} isCentered>
      <ModalOverlay />
      <ModalContent w="310px" px="4" pt="8" pb="6" alignItems="center">
        <Center boxSize="14" borderColor="#DAE2DA" borderWidth="1px" rounded="full" mb="3">
          <LockIcon fill="green.400" />
        </Center>
        <Text color="#ABABAB" fontWeight="500" mb="1">
          {t('news.premium.content.unlock')}
        </Text>
        <Text fontSize="22px" fontWeight="700" textAlign="center" mb="3.5">
          {t(powersQuery.data?.length ? 'news.premium.content.about_to_unlock' : 'news.premium.content.no_power')}
        </Text>
        <Flex gap="4">
          <Button variant="outline" onClick={props.onClose}>
            {' '}
            {t(powersQuery.data?.length ? 'app.actions.no' : 'app.actions.cancel')}
          </Button>
          <Button
            onClick={() => {
              if (!powersQuery.data?.length) router.push('/store/badges');
              else
                consumeMutation.mutate(
                  {id: powersQuery.data[0].id, news_item_id: news_id},
                  {
                    onSuccess: () => {
                      onUnlock?.();
                      invalidateNewsQuery();
                    },
                  },
                );
            }}
          >
            {powersQuery.data?.length ? t('app.actions.yes') : t('app.actions.goto', {location: t('app.store')})}
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
